/**
 * toggleSelectDistinct — thin edit-action wrapper for the `toggle-select-distinct`
 * SR-Edit op. No extra validation: the applicator already no-ops when the
 * statement is already in the requested DISTINCT state.
 */
import type { CommitEditCtx } from '../commitEdit';
import { commitEdit } from '../commitEdit';

export async function toggleSelectDistinct(distinct: boolean, ctx: CommitEditCtx): Promise<void> {
  await commitEdit({ op: 'toggle-select-distinct', distinct }, ctx);
}
